import { render, staticRenderFns } from "./RequestDataTable.vue?vue&type=template&id=686757f2&scoped=true"
import script from "@/components/request/RequestDataTable/RequestDataTable.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDataTable/RequestDataTable.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDataTable/request-data-table.scss?vue&type=style&index=0&id=686757f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686757f2",
  null
  
)

export default component.exports